// extracted by mini-css-extract-plugin
export default {"container":"modal__container___h80J3","isOpen":"modal__isOpen___kNTc_","inner":"modal__inner___29FpS","title":"modal__title___Shhyh","content":"modal__content___17jJi"};